<template>
    <div class>
        <el-card class="box-card" shadow="hover">
            <div style="margin-bottom: 20px;">
                <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
            </div>
            <div style="margin-bottom: 20px;">
                <el-button size="small" icon="el-icon-back" @click="submit()">提 交</el-button>
            </div>
            <el-form
                    :inline="true"
                    :rules="rules"
                    :model="agentForm"
                    ref="agentForm"
                    label-position="right"
                    label-width="120px">
                <el-tabs v-model="activeName">
                    <div class="m-title">资质信息&nbsp;&nbsp;<span style="font-size:12px;color:red;">【身份证正反面/手持照/结算照不可模糊,营业执照不可截图】【对私结算需上传结算声明
                        <el-button type="primary" style="padding: 4px 8px;"><el-link target="_blank" :href="statement_settlement" :underline="false" style='color:#fff;'>模板下载</el-link></el-button>】</span>
                    </div>
                    <div v-loading="imgLoading" element-loading-text="上传中,请稍等...." >
                        <el-form-item label="法人身份证正面照" prop="card_positive_img" style="display: none;" label-position="left" label-width="170px" id="fcert_file_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleFrontIdCardImg"
                            >
                                <img
                                        v-if="agentForm.card_positive_img_path != ''"
                                        :src="agentForm.card_positive_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/idcard_f3x.png')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="法人身份证反面照" prop="card_negative_img" style="display: none;"  label-position="left" label-width="170px" id="bcert_file_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleBackIdCardImg"
                            >
                                <img
                                        v-if="agentForm.card_negative_img_path != ''"
                                        :src="agentForm.card_negative_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/idcard_r3x.png')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="手持身份证照" prop="card_hand_hold_img" style="display: none;"  label-position="left" label-width="150px" id="hcert_file_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleCardHandHoldImg"
                            >
                                <img
                                        v-if="agentForm.card_hand_hold_img_path != ''"
                                        :src="agentForm.card_hand_hold_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/hand_hold.jpg')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="营业执照" prop="bus_license_img" style="display: none;"  label-position="left" label-width="130px" id="license_file_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleBusinessLicenseImg"
                            >
                                <img
                                        v-if="agentForm.bus_license_img != ''"
                                        :src="agentForm.bus_license_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/permit3x.png')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="结算银行卡照(对私必填)" prop="settle_card_img" style="display: none;"  label-position="left" label-width="170px" id="card_file_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleSettleCardImg"
                            >
                                <img
                                        v-if="agentForm.settle_card_img_path != ''"
                                        :src="agentForm.settle_card_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/card.jpg')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="开户许可证(对公必填)" prop="opening_permit_img" style="display: none;"  label-position="left" label-width="170px" id="permit_file_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleOpenAccountImg"
                            >
                                <img
                                        v-if="agentForm.opening_permit_img_path != ''"
                                        :src="agentForm.opening_permit_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/opening.jpg')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="门店门头照" prop="store_door_img" style="display: none;" label-position="left" label-width="130px" id="store_file_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleStoreDoorImg"
                            >
                                <img
                                        v-if="agentForm.store_door_img_path != ''"
                                        :src="agentForm.store_door_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/other3x.png')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="店内环境照片" prop="store_environment_img" style="display: none;"  label-position="left" label-width="150px" id="indoor_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleStoreEnvironmentImg"
                            >
                                <img
                                        v-if="agentForm.store_environment_img_path != ''"
                                        :src="agentForm.store_environment_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/other3x.png')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="结算声明"  style="display: none;"  label-position="left" label-width="130px" id="settle_file_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleStatementSettlementImg"
                            >
                                <img
                                        v-if="agentForm.statement_settlement_img_path != ''"
                                        :src="agentForm.statement_settlement_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/other3x.png')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="签约文件照片"  style="display: none;"  label-position="left" label-width="130px">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleSigningDocumentsImg"
                            >
                                <img
                                        v-if="agentForm.signing_documents_img_path != ''"
                                        :src="agentForm.signing_documents_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/other3x.png')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="门店收银台" prop="store_cashier_img" style="display: none;"  label-position="left" label-width="130px" id="cashier_desk_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleStoreCashierImg"
                            >
                                <img
                                        v-if="agentForm.store_cashier_img_path != ''"
                                        :src="agentForm.store_cashier_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/other3x.png')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="经营场所产权证明/租赁合同"  style="display: none;"  label-position="left" label-width="190px" id="lease_contract_id">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="uploadUrl"
                                    :show-file-list="false"
                                    :on-progress="handleImgLoading"
                                    :on-success="handleSecuritiesImg"
                            >
                                <img
                                        v-if="agentForm.securities_img_path != ''"
                                        :src="agentForm.securities_img_path"
                                        class="avatar"
                                />
                                <img
                                        v-else
                                        :src="require('../../assets/images/other3x.png')"
                                        class="avatar"
                                />
                            </el-upload>
                        </el-form-item>
                    </div>
                    <div class="m-title">基本信息&nbsp;&nbsp;<span style="font-size:12px;color:red;">【经营类别\商户名称\法人\地址等信息参照营业执照填写,注册资本企业商户必填】</span></div>
                    <el-form-item label="商户类型" prop="mch_type">
                        <el-select size="medium" v-model="agentForm.mch_type" placeholder="请选择商户类型">
                            <el-option label="个体商户" value="1"></el-option>
                            <el-option label="企业商户" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="账户类型" prop="account_type" style="display: none">
                        <el-select
                                size="medium"
                                v-model="agentForm.account_type"
                                placeholder="请选择账户类型"
                        >
                            <el-option label="对私" value="0"></el-option>
                            <el-option label="对公" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商户名称" id="store_name" prop="store_name" style="display: none">
                        <el-input
                                size="medium"
                                suffix-icon="el-icon-aux"
                                v-model="agentForm.mch_name"
                                placeholder="请输入商户名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="法人姓名" id="owner_name" prop="legal_person" style="display: none">
                        <el-input
                                size="medium"
                                suffix-icon="el-icon-aux"
                                v-model="agentForm.legal_person"
                                placeholder="请输入法人姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="法人手机号" id="owner_mobile" prop="legal_phone" style="display: none">
                        <el-input
                                size="medium"
                                suffix-icon="el-icon-aux"
                                v-model="agentForm.legal_phone"
                                placeholder="请输入法人手机号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="证件号" id="owner_cert_id" prop="id_card" style="display: none">
                        <el-input
                                size="medium"
                                suffix-icon="el-icon-aux"
                                v-model="agentForm.id_card"
                                placeholder="请输入证件号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="证件有效期" id="vaild_sdate" prop="card_valid_sdate" style="display: none">
                        <el-date-picker
                                v-model="cardRange"
                                type="daterange"
                                :clearable="false"
                                range-separator="至"
                                :disabled="isSelect"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                @change="handleCardChange"
                        ></el-date-picker>
                        <span style="margin-left:10px">
                                    <el-checkbox
                                            :true-label="1"
                                            :false-label="0"
                                            :disabled="agentForm.card_valid_sdate == ''"
                                            @change="handleCheckboxChange"
                                            v-model="is_long_time"
                                    >长期</el-checkbox>
                                </span>
                    </el-form-item>
                    <el-form-item label="商户经营地址" id="area_code" prop="union_pay_code" style="width:472px;display: none">
                        <el-select  style="width:90px;"
                                    size="medium"
                                    v-model="agentForm.prov_name"
                                    filterable
                                    @change="handleProChange"
                                    placeholder="省"
                        >
                            <el-option
                                    v-for="item in proList"
                                    :label="item.name"
                                    :value="item.code"
                                    :key="item.code"
                            ></el-option>
                        </el-select>
                        <el-select style="width:90px;"
                                   size="medium"
                                   v-model="agentForm.city_name"
                                   filterable
                                   @change="handleCityChange"
                                   placeholder="市"
                        >
                            <el-option
                                    v-for="item in cityList"
                                    :label="item.name"
                                    :value="item.code"
                                    :key="item.code"
                            ></el-option>
                        </el-select>
                        <el-select style="width:90px;"
                                   size="medium"
                                   v-model="agentForm.area_name"
                                   filterable
                                   @change="handleCountyChange"
                                   placeholder="区"
                        >
                            <el-option
                                    v-for="item in countyList"
                                    :label="item.name"
                                    :value="item.code"
                                    :key="item.code"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" id="addr" prop="addr_detail" style="display: none">
                        <el-input style="width:536px"
                                  size="medium"
                                  suffix-icon="el-icon-aux"
                                  v-model="agentForm.addr_detail"
                                  placeholder="请输入详细地址,至少包含【号、室、组、弄、巷、栋、房、交叉口】其中之一"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="统一社会信用代码" prop="credit_code" style="display: none">
                        <el-input
                                size="medium"
                                suffix-icon="el-icon-aux"
                                disabled
                                v-model="agentForm.credit_code"
                                placeholder="请输入统一社会信用代码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="营业执照有效期" prop="bus_license_valid_sdate" style="display: none" id="license_sdate">
                        <el-date-picker
                                v-model="licenseRange"
                                type="daterange"
                                :clearable="false"
                                range-separator="至"
                                :disabled="isSelect2"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                @change="handleLicenseChange"
                        ></el-date-picker>
                        <span style="margin-left:10px">
                                    <el-checkbox
                                            :true-label="1"
                                            :false-label="0"
                                            :disabled="agentForm.bus_license_valid_sdate == ''"
                                            @change="handleCheckboxChange2"
                                            v-model="is_bus_license_long_time"
                                    >长期</el-checkbox>
                                </span>
                    </el-form-item>
                    <el-form-item label="注册资本(元)" id="reg_capital" prop="reg_capital" style="display: none">
                        <el-input
                                size="medium"
                                suffix-icon="el-icon-aux"
                                v-model="agentForm.reg_capital"
                                placeholder="企业商户必填"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="经营类别" prop="mcc" style="display: none" id="mcc">
                        <el-select
                                size="medium"
                                v-model="agentForm.custom_code"
                                filterable
                                @change="handleMccChange"
                                placeholder="经营类别">
                            <el-option
                                    v-for="item in mccList"
                                    :label="item.name"
                                    :value="item.code"
                                    :key="item.code"
                            ></el-option>
                        </el-select>
                        <el-select
                            size="medium"
                            v-model="agentForm.mcc_name"
                            filterable
                            @change="handleMccsChange"
                            placeholder="经营类别"
                        >
                            <el-option
                                v-for="item in mccsList"
                                :label="item.name"
                                :value="item.mcc"
                                :key="item.mcc"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="经营范围" prop="business" style="display: none" id="business_scope">
                        <el-input style="width:350px"
                                  size="medium"
                                  suffix-icon="el-icon-aux"
                                  v-model="agentForm.business"
                                  placeholder="请输入经营范围"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="商户合同文件" prop="merchant_contract_img" style="display: none;text-align: center;margin-left: 26px;"  label-position="left" label-width="150px" id="contract_file_id">
                        <el-upload
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-progress="handleImgLoading"
                                :on-success="handleMerchantContractImg">
                            <el-button
                                    type="primary"
                                    style="font-size: 12px;margin-left: 44px;"
                                    v-if="merchant_contract_img==''"
                            >点击上传</el-button>
                            <div v-if="merchant_contract_img !==''">已上传(可点击重新提交)</div>
                        </el-upload>
                        <el-button
                                type="primary"
                                style="font-size: 12px;" v-if="is_upload_contract==2"
                        ><el-link target="_blank" :href="merchant_contract_img" :underline="false" style='color:#fff;'>下载已上传的协议</el-link></el-button>
                    </el-form-item>
                </el-tabs>
            </el-form>
        </el-card>
    </div>
</template>

<script>
import rules from './addAgentValid';
export default {
    data() {
        return {
            baseTabContent: [], //基础费率 -tab内容
            mList: [], //终端类型下拉框
            brandList: [], //终端类型下拉框
            snList: [], //终端类型下拉框
            flowList: [], //终端类型下拉框
            cashList: [], //终端类型下拉框
            storeForm: {
                merchant_id:this.$route.query.m_id,
                brand_id: '', //终端类型id
                brand_name: '', //终端类型id
                sn: "", //被选中的sn
                terminal_id: "", //被选中的sn
                brand_reward_conf_id:"",
                flowcard_brand_reward_conf_id:"",
                brand_reward_conf_name:"",
                flowcard_brand_reward_conf_name:"",
                name:"",
            },
            activeName: 'withdraw',
            licenseRange: [],   // 营业执照有效期
            cardRange: [],      // 身份证有效期
            uploadUrl: this.$api.uploadUrl, // 上传图片的地址
            loading: false,     // 提交loading
            imgLoading: false,  // 上传图片loading
            isSelect: false,    // 根据是否选中长期来判断身份证截止日期是否可选
            isSelect2: false,   // 根据是否选中长期来判断营业执照截止日期是否可选
            mccList:[],         // mcc
            mccsList:[],
            addressList:[],     // 省市区
            bankList: [],       // 银行列表
            branchList: [],     // 银行支行列表
            proList:[],
            cityList:[],
            countyList:[],
            is_bus_license_long_time: 0,    // 是否长期 营业执照
            is_long_time: 0,                // 是否长期 身份证
            agentForm: {
                card_positive_img: '',      // 身份证正面
                card_positive_img_path: '', // 身份证正面--展示
                card_negative_img: '',      // 身份证反面
                card_negative_img_path: '', // 身份证反面--展示
                bus_license_img: '',        // 营业执照 照片
                bus_license_img_path: '',   // 营业执照 照片--展示
                opening_permit_img: '',     // 开户许可照片
                opening_permit_img_path: '',// 开户许可照片--展示
                card_hand_hold_img:'',      // 手持身份证
                card_hand_hold_img_path:'', // 手持身份证--展示
                settle_card_img:'',         // 结算银行卡
                settle_card_img_path:'',    // 结算银行卡--展示
                store_door_img:'',          //门店门头照
                store_door_img_path:'',
                store_environment_img:'',   //店内环境照片
                store_environment_img_path:'',
                statement_settlement_img:'',    //结算声明
                statement_settlement_img_path:'',
                other_documents_img:'', //其他文件
                other_documents_img_path:'',
                handwritten_signature_img:'',   //手写签名
                handwritten_signature_img_path:'',
                signing_documents_img:'',   //签约文件照片
                signing_documents_img_path:'',
                store_cashier_img:'',       //门店收银台
                store_cashier_img_path:'',
                securities_img:'',          //经营场所产权证明
                securities_img_path:'',

                mch_type:0,//代理角色
                mch_name: '',               // 代理名
                legal_person: '',           // 法人
                legal_company:'',           // 公司名称
                legal_phone: '',            // 法人手机号
                id_card: '',                // 身份证
                card_valid_sdate: '',       // 身份证开始时间
                card_valid_edate: '',       // 身份证结束时间

                prov_code:"",               // 省代码
                city_code:"",               // 市代码
                area_code:"",               // 区代码
                prov_name:"",               // 省
                city_name:"",               // 市
                area_name:"",               // 区
                view_business_addr:'',      // 省市区
                addr_detail:"",             // 详细地址
                union_pay_code:'',

                credit_code:'',//营业执照信用代码

                bus_license_valid_sdate: '',// 营业执照开始时间
                bus_license_valid_edate: '',// 营业执照结束时间
                reg_capital:'',             // 注册资本
                business:'',                // 经营范围
                custom_code:'',
                mcc:'',
                mcc_name:'',

                account_type: '0',          // 账户类型
                account_name: '',           // 账户名
                bank_name: '',              // 银行id
                bank_prov:'',               // 银行所在省
                line_num: '',               // 联行号
                bank_code: '',              // 银行卡号
                branch_bank: '',            // 分行名
                bankSign: '',               // 选中银行的标识
                merchant_contract_img:'',   //商户合同文件
            },
            rules: rules,
            status:'',//进件步骤
            main_id:'',//进件步骤
            id:this.$route.query.id,//公司id
            whither_agreement:'https://ydoss.wondpay.cn//2021-08-12/1628753986262919437.docx',//空白模板
            route_agreement:'https://ydoss.wondpay.cn//2021-08-12/1628754240284827276.docx',//指南模板
            statement_settlement:'https://ydoss.wondpay.cn//0_gbase/授权委托书（委托收款）.pdf',//结算声明模板
            had_agreement:'',//指南模板
            merchant_contract_img:'',   //商户合同文件
            merchant_contract_img_path:'',
            is_upload_contract:1,
            merc_num:'',
            updateForm:''
        }
    },
    watch: {
        'agentForm.account_type'(newVal) { // 监听账户类型
            if (newVal == 0) {//对私
                this.agentForm.account_name = this.agentForm.legal_person;
            } else {
                this.agentForm.account_name = this.agentForm.legal_company;
            }
        },
    },
    created() {
        this.getbrandlist(); //获取MCC列表
        this.getBank(); //获取银行列表
        this.getAddress(); //获取地址列表
        this.getProAddress(); //获取地址列表
        this.getMcc(); //获取MCC列表
        this.getinit(); //获取初始信息
    },
    mounted() {

    },
    methods: {
        getinit() { // 获取初始信息
            this.$api.post("merchant_company/getOneCompanyMerchant", {id:this.id}, res => {
                if (res.code == 0) {
                    this.agentForm.mch_type=res.data.merchant_type;
                    this.agentForm.credit_code=res.data.license_no;
                    this.status=res.data.status;
                    this.main_id=res.data.main_id;
                    this.had_agreement=res.data.had_agreement;
                    this.is_upload_contract=res.data.is_upload_contract;
                    this.merchant_contract_img=res.data.merchant_contract_photo;
                    this.merc_num=res.data.merc_num;
                    this.auditFail(res.data.audit_fail) // 修改内容

                    this.getCompanyMerchantNetCache(); //获取缓存信息
                    if(res.data.terminal){
                        this.storeForm=res.data.terminal;
                        if(res.data.terminal.brand_id){
                            this.$api.post('terminal_transfer/get_transfer_terminal', { brand_id: res.data.terminal.brand_id }, res => { //划拨用户
                                if (res.code == 0) {
                                    this.snList = res.data;
                                    this.getflowList(res.data.terminal.brand_id);
                                    this.getcashList(res.data.terminal.brand_id);
                                }
                            });
                        }
                    }
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        handleCheckboxChange(value) { // 处理是否长期
            if (value == 1) {
                this.isSelect = true;
                if (this.cardRange.length) { // 已选择有效期后进行修改
                    this.cardRange = [this.cardRange[0], '9999-12-31'];
                    this.agentForm.card_valid_edate = '9999-12-31';
                }
            } else {
                this.isSelect = false;
                if (this.cardRange.length) {
                    this.cardRange = [this.cardRange[0], this.$moment(Date.now()).format('YYYY-MM-DD')];
                    this.agentForm.card_valid_edate = '';
                }
            }
        },
        handleCheckboxChange2(value) { // 处理是否长期
            if (value == 1) {
                this.isSelect2 = true;
                if (this.licenseRange.length) { // 已选择有效期后进行修改
                    this.licenseRange = [this.licenseRange[0], '9999-12-31'];
                    this.agentForm.bus_license_valid_edate = '9999-12-31';
                }
            } else {
                this.isSelect2 = false;
                if (this.licenseRange.length) {
                    this.licenseRange = [this.licenseRange[0], this.$moment(Date.now()).format('YYYY-MM-DD')];
                    this.agentForm.bus_license_valid_edate = '';
                }
            }
        },
        handleImgLoading() { // 上传文件时加载loading
            this.imgLoading = true;
        },
        handleBusinessLicenseImg(res) { // 营业执照
            this.upImg({
                res,
                path: 'bus_license_img',
                img: 'bus_license_img_path'
            },3);
        },
        handleCardHandHoldImg(res) { // 手持身份证
            this.upImg({
                res,
                path: 'card_hand_hold_img',
                img: 'card_hand_hold_img_path'
            },0);
        },
        handleSettleCardImg(res) { // 结算银行卡
            this.upImg({
                res,
                path: 'settle_card_img',
                img: 'settle_card_img_path'
            },4);
        },
        handleOpenAccountImg(res) { // 开户许可证
            this.upImg({
                res,
                path: 'opening_permit_img',
                img: 'opening_permit_img_path'
            },0);
        },
        handleFrontIdCardImg(res) { // 身份证正面
            this.upImg({
                res,
                path: 'card_positive_img',
                img: 'card_positive_img_path'
            },1);
        },
        handleBackIdCardImg(res) { // 身份证反面
            this.upImg({
                res,
                path: 'card_negative_img',
                img: 'card_negative_img_path'
            },2);
        },
        handleStoreDoorImg(res) { // 门店门头照
            this.upImg({
                res,
                path: 'store_door_img',
                img: 'store_door_img_path'
            },0);
        },
        handleStoreEnvironmentImg(res) { // 店内环境照片
            this.upImg({
                res,
                path: 'store_environment_img',
                img: 'store_environment_img_path'
            },0);
        },
        handleMerchantContractImg(res) { // 商户合同文件
            this.upFile(res);
        },
        handleStatementSettlementImg(res) { // 结算声明
            this.upImg({
                res,
                path: 'statement_settlement_img',
                img: 'statement_settlement_img_path'
            },0);
        },
        handleSigningDocumentsImg(res) { // 签约文件照片
            this.upImg({
                res,
                path: 'signing_documents_img',
                img: 'signing_documents_img_path'
            },0);
        },
        handleStoreCashierImg(res) { // 门店收银台
            this.upImg({
                res,
                path: 'store_cashier_img',
                img: 'store_cashier_img_path'
            },0);
        },
        handleSecuritiesImg(res) { // 经营场所产权证明
            this.upImg({
                res,
                path: 'securities_img',
                img: 'securities_img_path'
            },0);
        },
        getBank() { // 获取银行列表
            this.$api.post("bank/list", {}, res => {
                if (res.code == 0) {
                    this.bankList = res.data;
                }
            })
        },
        getAddress() { // 获取银行省列表
            this.$api.post("MerchantNet/getAddr", {}, res => {
                if (res.code == 0) {
                    this.addressList = res.data;
                }
            })
        },
        getProAddress() { // 获取银行省列表
            this.$api.post("MerchantNet/getAddr", {}, res => {
                if (res.code == 0) {
                    this.proList = res.data;
                }
            })
        },
        getMcc() { // 获取mcc列表
            this.$api.post("MerchantNet/getMcc", {}, res => {
                if (res.code == 0) {
                    this.mccList = res.data;
                }
            })
        },
        handleMccChange(bankVal) { // 处理银行选中时获取值
            this.mccsList=[];
            this.agentForm.mcc_name='';
            this.$api.post("MerchantNet/getMcc", {custom_code:bankVal,is_personal:this.agentForm.mch_type}, res => {
                if (res.code == 0) {
                    this.mccsList = res.data;
                }
            })
        },
        handleMccsChange(bankVal) { // 处理银行选中时获取值
            let bank = this.mccsList.filter(item => {
                return item.mcc == bankVal;
            });
            this.agentForm.mcc_name = bank[0].name;
            this.agentForm.mcc = bank[0].mcc;
        },
        handleProChange(bankVal) { // 处理省选中时获取值
            let bank = this.proList.filter(item => {
                return item.code == bankVal;
            });
            this.agentForm.prov_name = bank[0].name;
            this.agentForm.prov_code = bank[0].code;
            this.cityList=[];
            this.countyList=[];
            this.$api.post("MerchantNet/getAddr", {parent_code:bankVal}, res => {
                if (res.code == 0) {
                    this.cityList = res.data;
                }
            })
        },
        handleCityChange(bankVal) { // 处理市选中时获取值
            let bank = this.cityList.filter(item => {
                return item.code == bankVal;
            });
            this.agentForm.city_name = bank[0].name;
            this.agentForm.city_code = bank[0].code;
            this.countyList=[];
            this.$api.post("MerchantNet/getAddr", {parent_code:bankVal}, res => {
                if (res.code == 0) {
                    this.countyList = res.data;
                }
            })
        },
        handleCountyChange(bankVal) { // 处理区选中时获取值
            let bank = this.countyList.filter(item => {
                return item.code == bankVal;
            });
            this.agentForm.area_name = bank[0].name;
            this.agentForm.area_code = bank[0].code;
            this.agentForm.union_pay_code = bank[0].union_pay_code;
            this.agentForm.view_business_addr=this.agentForm.prov_name+"-"+this.agentForm.city_name+"-"+this.agentForm.area_name;
        },
        getCompanyRate() { // 获取初始费率
            this.$api.post("merchant_company/getCompanyMerchantRate", {}, res => {
                if (res.code == 0) {
                    this.baseTabContent = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        getBrand(brandName) { //获取终端
            let branchLineNum = this.brandList.filter(item => {
                return item.name == brandName;
            });
            this.storeForm.brand_id=branchLineNum[0]['id'];
            this.storeForm.brand_name=branchLineNum[0]['name'];
            this.$api.post('terminal_transfer/get_transfer_terminal', { brand_id: branchLineNum[0]['id'] }, res => { //划拨用户
                if (res.code == 0) {
                    this.snList = res.data;
                    this.flowList = "";
                    this.cashList = "";
                    this.storeForm.sn = ""; // 联行号
                    this.storeForm.terminal_id = ""; // 联行号
                    this.storeForm.brand_reward_conf_id = ""; // 联行号
                    this.storeForm.flowcard_brand_reward_conf_id = ""; // 联行号
                    this.storeForm.brand_reward_conf_name = ""; // 联行号
                    this.storeForm.flowcard_brand_reward_conf_name = ""; // 联行号
                    this.getflowList(branchLineNum[0]['id']);
                    this.getcashList(branchLineNum[0]['id']);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getflowList(brandId){//流量卡列表
            this.$api.post('terminal/get_flow_back_list', { brand_id: brandId }, res => { //划拨用户
                if (res.code == 0) {
                    this.flowList = res.data.setting;
                }
            });
        },
        getcashList(brandId){//押金列表
            this.$api.post('terminal/get_cash_back_list', { brand_id: brandId }, res => { //划拨用户
                if (res.code == 0) {
                    this.cashList = res.data.setting;
                }
            });
        },
        getCash(bankVal) { // 选择押金操作
            let bank = this.cashList.filter(item => {
                return item.name == bankVal;
            });
            this.storeForm.brand_reward_conf_id = bank[0].brand_reward_conf_id;
            this.storeForm.brand_reward_conf_name = bank[0].name;
        },
        getFlow(bankVal) { // 选中流量卡操作
            let bank = this.flowList.filter(item => {
                return item.name == bankVal;
            });
            this.storeForm.flowcard_brand_reward_conf_id = bank[0].brand_reward_conf_id;
            this.storeForm.flowcard_brand_reward_conf_name = bank[0].name;
        },
        getbrandlist(){
            this.$api.post('brand/brand_list', {}, res => { //获取终端类型
                if (res.code == 0) {
                    this.brandList = res.data.list;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getCompanyMerchantNetCache() { // 获取redis信息
            this.$api.post("merchant_company/getCompanyMerchantNetCache", {license_no:this.agentForm.credit_code,mch_type:this.agentForm.mch_type}, res => {
                if (res.code == 0) {
                    if(!res.data.baseTabContent){
                        this.getCompanyRate(); //获取MCC列表
                    }else{
                        this.baseTabContent=res.data.baseTabContent;
                    }
                    if(res.data.agentForm){
                        var list=res.data.agentForm;
                        if(list.card_positive_img){this.agentForm.card_positive_img=list.card_positive_img;this.agentForm.card_positive_img_path=list.card_positive_img_path}      // 身份证正面
                        if(list.card_negative_img){this.agentForm.card_negative_img=list.card_negative_img;this.agentForm.card_negative_img_path=list.card_negative_img_path}      // 身份证反面
                        if(list.bus_license_img){this.agentForm.bus_license_img=list.bus_license_img;this.agentForm.bus_license_img_path=list.bus_license_img_path}      // 营业执照
                        if(list.opening_permit_img){this.agentForm.opening_permit_img=list.opening_permit_img;this.agentForm.opening_permit_img_path=list.opening_permit_img_path}      // 开户许可照片
                        if(list.card_hand_hold_img){this.agentForm.card_hand_hold_img=list.card_hand_hold_img;this.agentForm.card_hand_hold_img_path=list.card_hand_hold_img_path}      // 手持身份证
                        if(list.settle_card_img){this.agentForm.settle_card_img=list.settle_card_img;this.agentForm.settle_card_img_path=list.settle_card_img_path}      // 结算银行卡


                        if(list.store_door_img){this.agentForm.store_door_img=list.store_door_img;this.agentForm.store_door_img_path=list.store_door_img_path}      // 结算银行卡
                        if(list.store_environment_img){this.agentForm.store_environment_img=list.store_environment_img;this.agentForm.store_environment_img_path=list.store_environment_img_path}      // 结算银行卡
                        // if(list.merchant_contract_img){this.agentForm.merchant_contract_img=list.merchant_contract_img;this.agentForm.merchant_contract_img_path=list.merchant_contract_img_path}      // 结算银行卡
                        if(list.statement_settlement_img){this.agentForm.statement_settlement_img=list.statement_settlement_img;this.agentForm.statement_settlement_img_path=list.statement_settlement_img_path}      // 结算银行卡
                        if(list.other_documents_img){this.agentForm.other_documents_img=list.other_documents_img;this.agentForm.other_documents_img_path=list.other_documents_img_path}      // 结算银行卡
                        if(list.handwritten_signature_img){this.agentForm.handwritten_signature_img=list.handwritten_signature_img;this.agentForm.handwritten_signature_img_path=list.handwritten_signature_img_path}      // 结算银行卡
                        if(list.signing_documents_img){this.agentForm.signing_documents_img=list.signing_documents_img;this.agentForm.signing_documents_img_path=list.signing_documents_img_path}      // 结算银行卡
                        if(list.store_cashier_img){this.agentForm.store_cashier_img=list.store_cashier_img;this.agentForm.store_cashier_img_path=list.store_cashier_img_path}      // 结算银行卡
                        if(list.securities_img){this.agentForm.securities_img=list.securities_img;this.agentForm.securities_img_path=list.securities_img_path}      // 结算银行卡

                        if(list.mch_type){this.agentForm.mch_type=list.mch_type}      // 商户角色
                        if(list.mch_name){this.agentForm.mch_name=list.mch_name}      // 商户名称
                        if(list.legal_person){this.agentForm.legal_person=list.legal_person}      // 法人
                        if(list.legal_phone){this.agentForm.legal_phone=list.legal_phone}      // 法人手机号
                        if(list.id_card){this.agentForm.id_card=list.id_card}      // 身份证
                        if(list.card_valid_edate){
                            this.agentForm.card_valid_sdate=list.card_valid_sdate;// 身份证开始时间
                            this.agentForm.card_valid_edate=list.card_valid_edate;// 身份证结束时间
                            this.cardRange=[list.card_valid_sdate,list.card_valid_edate];      // 身份证有效期
                            if(list.card_valid_edate=="9999-12-31"){
                                this.isSelect=true;
                                this.is_long_time=1;
                            }
                        }

                        if(list.prov_code){
                            this.agentForm.prov_code=list.prov_code;
                            this.$api.post("MerchantNet/getAddr", {parent_code:list.prov_code}, res => {
                                if (res.code == 0) {
                                    this.countyList = res.data;
                                }
                            })
                        }      // 省代码
                        if(list.city_code){
                            this.agentForm.city_code=list.city_code;
                            this.$api.post("MerchantNet/getAddr", {parent_code:list.city_code}, res => {
                                if (res.code == 0) {
                                    this.countyList = res.data;
                                }
                            })
                        }      // 市代码
                        if(list.area_code){this.agentForm.area_code=list.area_code}      // 区代码
                        if(list.prov_name){this.agentForm.prov_name=list.prov_name}      // 省
                        if(list.city_name){this.agentForm.city_name=list.city_name}      // 市
                        if(list.area_name){this.agentForm.area_name=list.area_name}      // 区
                        if(list.view_business_addr){this.agentForm.view_business_addr=list.view_business_addr}      // 省市区
                        if(list.addr_detail){this.agentForm.addr_detail=list.addr_detail}      // 详细地址
                        if(list.union_pay_code){this.agentForm.union_pay_code=list.union_pay_code}      // 地区码

                        if(list.credit_code){this.agentForm.credit_code=list.credit_code}      // 营业执照信用代码
                        if(list.reg_capital){this.agentForm.reg_capital=list.reg_capital}      // 注册资本
                        if(list.business){this.agentForm.business=list.business}      // 经营范围
                        if(list.mcc){
                            this.agentForm.mcc_name=list.mcc_name;
                            this.agentForm.custom_code=list.custom_code;
                            this.agentForm.mcc=list.mcc;
                            this.$api.post("MerchantNet/getMcc", {custom_code:list.custom_code,is_personal:list.mch_type}, res => {
                                if (res.code == 0) {
                                    this.mccsList = res.data;
                                }
                            })
                        }      // 地区码
                        if(list.bus_license_valid_edate){
                            this.agentForm.bus_license_valid_sdate=list.bus_license_valid_sdate;// 营业执照开始时间
                            this.agentForm.bus_license_valid_edate=list.bus_license_valid_edate;// 营业执照结束时间
                            this.licenseRange=[list.bus_license_valid_sdate,list.bus_license_valid_edate];      // 营业执照有效期
                            if(list.bus_license_valid_edate=="9999-12-31"){
                                this.isSelect2=true;
                                this.is_bus_license_long_time=1;
                            }
                        }

                        if(list.legal_company){this.agentForm.legal_company=list.legal_company}      // 账户名
                        if(list.account_name){this.agentForm.account_name=list.account_name}      // 账户名
                        if(list.bank_name){this.agentForm.bank_name=list.bank_name}      // 银行名称
                        if(list.account_type){
                            this.agentForm.account_type=list.account_type;
                        }      // 银行名称

                        if(list.bank_code){this.agentForm.bank_code=list.bank_code}      // 银行卡号
                        if(list.branch_bank){this.agentForm.branch_bank=list.branch_bank}      // 分行名
                        if(list.bankSign && list.bank_prov){
                            this.$api.post('bank/branch', { bank_symbol: list.bankSign, bank_prov: list.bank_prov}, res => {
                                if (res.code == 0) {
                                    this.agentForm.line_num = '';
                                    this.branchList = [];
                                    this.branchList = res.data.bank;
                                    if(list.line_num){this.agentForm.line_num=list.line_num}      // 联行号
                                    if(list.bank_prov){this.agentForm.bank_prov=list.bank_prov}      // 银行所在省
                                    if(list.bankSign){this.agentForm.bankSign=list.bankSign}      // 银行所在省
                                } else {
                                    this.$message.error('获取支行信息失败，请重新选择银行或归属地进行获取!');
                                }
                            });
                        }
                    }
                }else{
                    this.getCompanyRate(); //获取MCC列表
                }
            })
        },
        upImg(res,type) { //公用
            let resData = res.res;
            if (resData.code === 0) {
                this.agentForm[res.img] = resData.data.file_url; //展示路径
                this.agentForm[res.path] = resData.data.file_path //请求路径
                this.$api.OCR_POST("getPhotoInfo", {image:resData.data.file_url,type:type}, res => {
                    if (res.code == 0) {
                        if(type==1){
                            this.agentForm.id_card=res.data.num;
                        }
                        if(type==2){
                            this.cardRange = [res.data.start_date, res.data.end_date];
                            this.agentForm.card_valid_sdate=res.data.start_date;
                            this.agentForm.card_valid_edate=res.data.end_date;
                            if(res.data.end_date=="9999-12-31"){
                                this.isSelect = true;
                                this.is_long_time=1;
                            }else{
                                this.isSelect = false;
                                this.is_long_time=0;
                            }
                        }
                        if(type==3){
                            this.agentForm.bus_license_valid_sdate=res.data.establish_date;
                            this.agentForm.bus_license_valid_edate=res.data.valid_period;
                            this.agentForm.business=res.data.business;
                            this.licenseRange= [res.data.establish_date, res.data.valid_period];
                            this.agentForm.credit_code=res.data.reg_num;
                            this.agentForm.addr_detail=res.data.address;
                            if(this.agentForm.account_type=='0'){//对私
                                this.agentForm.account_name=res.data.person;
                            }
                            if(this.agentForm.account_type=='2'){//对公
                                this.agentForm.account_name=res.data.name;
                            }
                            this.agentForm.legal_person=res.data.person;
                            this.agentForm.legal_company=res.data.name;
                            if(res.data.valid_period=="9999-12-31"){
                                this.isSelect2 = true;
                                this.is_bus_license_long_time=1;
                            }else{
                                this.isSelect2 = false;
                                this.is_bus_license_long_time=0;
                            }
                        }
                    }
                })
            } else {
                //错误提示
                this.$message.error(res.msg);
            }
            this.imgLoading = false;
        },
        upFile(res) { //公用
            if (res.code === 0) {
                this.agentForm.merchant_contract_img = res.data.file_path; //展示路径
                this.merchant_contract_img_path = res.data.file_path //请求路径
            } else {
                //错误提示
                this.$message.error(res.msg);
            }
            this.imgLoading = false;
        },
        handleLicenseChange(dateArr) { // 营业执照有效期处理
            if (dateArr) {
                this.agentForm.bus_license_valid_sdate = dateArr[0];
                this.agentForm.bus_license_valid_edate = dateArr[1];
            }
        },
        handleCardChange(dateArr) { // 身份证有效期处理
            if (dateArr) {
                this.agentForm.card_valid_sdate = dateArr[0];
                this.agentForm.card_valid_edate = dateArr[1];
            }
        },
        auditFail(res)
        {
            this.data = res.split(';');
            this.updateForm = res.split(';');
            for (let i = 0; i < this.data.length; i++) {
                var txt = '#'+this.data[i];
                $(txt).show()
                if(this.data[i] == 'fcert_file_id'){  //身份证正面
                    this.updateForm[i] = 'card_positive_img'
                }
                if(this.data[i] == 'bcert_file_id'){  //身份证反面
                    this.updateForm[i] = 'card_negative_img'
                }
                if(this.data[i] == 'hcert_file_id'){  //手持身份证
                    this.updateForm[i] = 'card_hand_hold_img'
                }
                if(this.data[i] == 'card_file_id'){  //结算卡
                    this.updateForm[i] = 'settle_card_img'
                }
                if(this.data[i] == 'permit_file_id'){  //开户许可证
                    this.updateForm[i] = 'opening_permit_img'
                }
                if(this.data[i] == 'license_file_id'){  //营业执照
                    this.updateForm[i] = 'bus_license_img'
                }
                if(this.data[i] == 'store_file_id'){  //门头
                    this.updateForm[i] = 'store_door_img'
                }
                if(this.data[i] == 'indoor_id'){  //店内环境
                    this.updateForm[i] = 'store_environment_img'
                }
                if(this.data[i] == 'contract_file_id'){  //商户合同文件
                    this.updateForm[i] = 'merchant_contract_img'
                }
                if(this.data[i] == 'settle_file_id'){  //结算声明
                    this.updateForm[i] = 'statement_settlement_img'
                }
                if(this.data[i] == 'cashier_desk_id'){  //门店收银台
                    this.updateForm[i] = 'store_cashier_img'
                }
                if(this.data[i] == 'lease_contract_id'){  //经营场所产权证明/租赁合同
                    this.updateForm[i] = 'securities_img'
                }
                if(this.data[i] == 'store_name'){  //商户名称
                    this.updateForm[i] = 'mch_name'
                }
                if(this.data[i] == 'store_name'){  //商户名称
                    this.updateForm[i] = 'mch_name'
                }
                if(this.data[i] == 'owner_name'){  //法人姓名
                    this.updateForm[i] = 'legal_person'
                }
                if(this.data[i] == 'owner_mobile'){  //法人手机号
                    this.updateForm[i] = 'legal_phone'
                }
                if(this.data[i] == 'owner_cert_id'){  //法人证件号
                    this.updateForm[i] = 'id_card'
                }
                if(this.data[i] == 'vaild_sdate'){  //身份证开始日期
                    this.updateForm[i] = 'card_valid_sdate'
                }
                if(this.data[i] == 'vaild_edate'){  //身份证结束日期
                    this.updateForm[i] = 'card_valid_edate'
                }
                if(this.data[i] == 'area_code'){  //商户经营地区
                    this.updateForm[i] = 'area_code'
                    this.updateForm[i] = 'prov_code'
                    this.updateForm[i] = 'city_code'
                }
                if(this.data[i] == 'addr'){  //商户经营地址
                    this.updateForm[i] = 'addr_detail'
                }
                if(this.data[i] == 'license_sdate'){  //营业执照有效期
                    this.updateForm[i] = 'bus_license_valid_sdate'
                    this.updateForm[i] = 'bus_license_valid_edate'
                }
                if(this.data[i] == 'reg_capital'){  //注册资本
                    this.updateForm[i] = 'reg_capital'
                }
                if(this.data[i] == 'business_scope'){  //经营范围
                    this.updateForm[i] = 'business'
                }
                if(this.data[i] == 'mcc'){  //经营类别
                    this.updateForm[i] = 'mcc'
                }
            }
        },
        submit() {
            var lessons = []
            var txt = '{'
            for (let i = 0; i < this.updateForm.length; i++) {
                for(let key  in this.agentForm){
                    if(key == this.updateForm[i]){
                        lessons[key] = this.agentForm[key]
                        txt += '"'+key+'":"'+this.agentForm[key]+'",'
                    }
                }
            }
            txt = txt.substr(0,txt.length-1)
            txt += '}'
            var obj = JSON.parse(txt);
            obj.id = this.$route.query.id;
            this.$api.post('merchant/getCompanyUpdate', obj , res => {
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: res.msg,
                        duration: 1000,
                    })
                }
            });
        },
    }
}
</script>

<style scoped lang="scss">
.setUserRate {
  ::v-deep .el-form-item__label {
    font-size: 12px;
    font-weight: 700;
  }
  ::v-deep .el-input__inner {
    width: 200px;
  }
  ::v-deep .el-dialog {
    height: 80%;
    .el-dialog__body {
      height: 82%;
      overflow: auto;
    }
  }
  .type_title {
    margin: 10px 0;
    font-size: 13px;
    font-weight: 700;
    border-left: 5px solid #40b8ff;
    padding: 0 0 0 10px;
  }
}
.el-form-item {
  margin-bottom: 22px;
}
.m-title {
  color: #303133;
  font-size: 14px;
  font-weight: 700;
  padding-left: 10px;
  margin: 10px 0;
  border-left: 4px solid #409eff;
}
.line {
  text-align: center;
}
::v-deep .el-input-group__append {
  color: #ffffff;
  font-size: 12px;
  background-color: #409eff;
}
.el-form-item__content .el-input-group {
  vertical-align: middle;
}
.avatar-uploader {
  width: 200px;
  height: 130px;
  border-radius: 10px;
  overflow: hidden;
}
::v-deep .avatar-uploader .el-upload {
  width: 100%;
  height: 100%;
}
.avatar {
  width: 100%;
  height: 100%;
}
</style>
